(function () {
  document.querySelectorAll('form[data-smartrr-form-id]').forEach(function (form) {
    var productId = form.getAttribute('data-smartrr-form-id');
    if (!productId) return;

    var hiddenIdInput = form.querySelector('input[name="id"][data-product-select]');
    if (!hiddenIdInput) return;

    function syncSmartrrVariant() {
      var entry = window.smartrrProductList && window.smartrrProductList[productId];
      if (!entry || !entry.logic) return;
      var variantId = Number(hiddenIdInput.value);
      if (variantId) {
        entry.logic.apiChangeVariant(variantId);
      }
    }

    form.querySelectorAll('[data-single-option-selector]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        setTimeout(syncSmartrrVariant, 0);
      });
    });
  });
})();